import React, { useState } from "react";
import PhoneSearch from "@/components/PhoneSearch";
import TransparencyProfile from "@/components/TransparencyProfile";
import Seo from "@/components/Seo";
import Breadcrumbs from "@/components/Breadcrumbs";
import { breadcrumbLd } from "@/lib/siteContent";
import { Search } from "lucide-react";

const crumbs = [{ label: "Home", to: "/" }, { label: "Check Before You Trust", to: "/check-before-you-trust" }];

export default function CheckBeforeHiring() {
  const [result, setResult] = useState(null);
  return (
    <div className="ca-container py-12 max-w-4xl">
      <Seo title="Check Before Hiring a Service Provider | ComplaintAdvisor"
        description="Review available customer and vendor information before starting work, hiring a service provider, paying an advance, or entering a business relationship."
        path="/check-before-you-trust" jsonld={breadcrumbLd(crumbs)} />
      <Breadcrumbs items={crumbs} />
      <span className="inline-flex items-center gap-1.5 rounded-full bg-teal-brand/10 text-teal px-3 py-1 text-xs font-semibold mt-3 mb-3">
        <Search className="h-3.5 w-3.5" /> Consent-based lookup
      </span>
      <h1 className="font-display text-3xl sm:text-4xl font-bold text-slate-900">Check Before You Trust</h1>
      <p className="text-slate-600 mt-2">
        Before beginning a business relationship, review available information and clarify expectations. Search available
        profiles, feedback, complaint status, and response information. Entering a number does not reveal private
        information, and results do not establish guilt.
      </p>
      <div className="mt-6">
        <PhoneSearch onResult={setResult} />
      </div>
      {result && (
        <div className="mt-6 rounded-2xl border border-slate-200 bg-white p-6 ca-fade-up">
          <TransparencyProfile profile={result} />
        </div>
      )}
      <div className="mt-8 rounded-xl bg-slate-50 border border-slate-200 p-4 text-sm text-slate-600">
        Search results are informational and may not represent the complete history of a person or business. A complaint is
        not proof of wrongdoing, and the absence of a complaint is not proof that no issue has occurred.
      </div>
    </div>
  );
}
